import { render } from "./DatasetCheckout.vue?vue&type=template&id=636b7b01"
import script from "./DatasetCheckout.vue?vue&type=script&lang=js"
export * from "./DatasetCheckout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__